import { api } from "@/lib/api-client";
import type { Paginated } from "../agents/api";

export type Integration = {
  id: string;
  name: string;
  integration_type: string;
  is_active?: boolean;
  config?: Record<string, unknown>;
  has_credentials?: boolean;
  credential_keys?: string[];
  /** Non-secret saved credential values (username, event_type_id, …). Secrets are never included. */
  safe_credentials?: Record<string, string>;
  auto_settings?: { timezone?: string; [k: string]: unknown };
};

export type IntegrationCreate = {
  name: string;
  integration_type: string;
  credentials: Record<string, string>;
  config?: Record<string, unknown>;
};

export const integrationsApi = {
  list: async () => {
    const res = await api.get<Paginated<Integration> | Integration[]>(
      "/integrations/",
    );
    return Array.isArray(res.data) ? res.data : res.data.results;
  },
  create: async (data: IntegrationCreate) => {
    const res = await api.post<Integration>("/integrations/", data);
    return res.data;
  },
  update: async (
    id: string,
    data: {
      credentials?: Record<string, string>;
      config?: Record<string, unknown>;
      is_active?: boolean;
    },
  ) => {
    const res = await api.patch<Integration>(`/integrations/${id}/`, data);
    return res.data;
  },
  disconnect: async (id: string) => {
    await api.post(`/integrations/${id}/disconnect/`);
  },
  test: async (id: string) => {
    const res = await api.post<{ status: string; message: string }>(
      `/integrations/${id}/test/`,
    );
    return res.data;
  },
};

export const CRM_INTEGRATION_TYPES: ReadonlyArray<string> = [
  "hubspot",
  "salesforce",
  "custom",
];

export function isCrmIntegration(type: string): boolean {
  return CRM_INTEGRATION_TYPES.includes(type);
}
